import { gql } from '@apollo/client';

export const GENERIC_ENTITY_FLOW_TRANSITION_CHANGED = gql`
  subscription genericEntityFlowTransitionChanged {
    genericEntityFlowTransitionChanged {
      transitionId
      siteId
      flowId
      initialStateId
      finalStateId
      allowedForAllUserGroups
      fourEyesPrinciple
      requestBusinessMomentOnChange
      requestReasonOnChange
      saveHistory
      userGroups {
        flowId
        groupId
        siteId
        transitionId
        allowed
      }
    }
  }
`;

export const GENERIC_ENTITY_FLOW_TRANSITION_DELETED = gql`
  subscription genericEntityFlowTransitionDeleted {
    genericEntityFlowTransitionDeleted {
      transitionId
    }
  }
`;
